import { useEffect, useState } from "react";
import { MastersService } from "../api";

export const useMaster = (table: string) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await MastersService.fetchMasterRawMastersRawModelNameGet(table);
        // console.log("Master Fetch", table, res);
        setData(res);
      } catch (err) {
        // ✅ Catch block to log errors
        console.error("Error fetching master data:", table, err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [table]);

  return { data, loading };
};
